<div class="sidebar" [ngClass]="isShow ? 'menu_show': ''">
    <div class="sidebar_body" (mouseleave)="dismissSidebar()">
        <div class="sidebar_container">
            <div class="Subpart_body">
                <div class="subpart_header">
                    <div class=""><span class="material-symbols-outlined icon-box">person </span></div>
                    <div class=""> Employee </div>
                </div>
                <div class="subpart_container">
                    <ul class="menu">
                        <li class="menu-item" *ngIf="hideMenu.dashboard" >
                            <!-- <div class="image-box-two"><span class="material-symbols-outlined icon-box">group </span></div> -->
                            <a routerLinkActive="active" [routerLink]="['/Home/Dashboard']" (click)="dismissSidebar()">My Dashboard</a>
                        </li>
                        <li class="menu-item"  *ngIf="showemployeeimpersonation" >
                            <!-- <div class="image-box-two"><span class="material-symbols-outlined icon-box">group </span></div> -->
                            <a routerLinkActive="active" [routerLink]="['Home/Dashboard/Employee Impersonation']" (click)="gotoaccessemployeedashboard()">Employee Impersonation</a>
                        </li>
                        
                        <li class="" *ngIf="hideMenu.dashboard">
                            <div class="emp_career_item fw-600 employee_carrer">
                                Employee Career
                            </div>
                            <div class="employee_carrer_body">
                                <ul class="submenu">
                                    <li class="submenu-item">
                                        <!-- <div class="image-box-two"><span class="material-symbols-outlined icon-box">group </span></div> -->
                                        <a [routerLink]="['/Home/employee-career/employee-Career-path']"
                                            routerLinkActive="active" (click)="employeeCareerPathNavigate()">Career
                                            Path</a>
                                    </li>
                                    <li class="submenu-item">
                                        <!-- <div class="image-box-two"><span class="material-symbols-outlined icon-box">group </span></div> -->
                                        <a [routerLink]="['Home/employee-career/employee-Career-program']"
                                            routerLinkActive="active" (click)="employeeCareerProgramNavigate()">Career
                                            Program</a>
                                    </li>
                                    <li class="submenu-item">
                                        <!-- <div class="image-box-two"><span class="material-symbols-outlined icon-box">group </span></div> -->
                                        <a [routerLink]="['/Home/employee-career/program-catalogue']"
                                            routerLinkActive="active" (click)="programCatalogueNavigate()">Program
                                            Catalogue</a>

                                    </li>
                                    <li class="submenu-item" *ngIf="isEmpCareerManager || accessForAddPrograms">
                                        <!-- <div class="image-box-two"><span class="material-symbols-outlined icon-box">group </span></div> -->
                                        <a [routerLink]="['/Home/employee-career/add-programs']"
                                            routerLinkActive="active" (click)="AddprogramsNavigate()">Add
                                            Programs</a>
                                    </li>
                                    <li class="">
                                        <div class="emp_career_item fw-600 employee_carrer">
                                            Career Request
                                        </div>
                                        <div class="employee_carrer_body">
                                            <ul class="submenu">
                                                <li class="submenu-item">
                                                    <a [routerLink]="['/Home/employee-career/employee-Career-request/my-requests']"
                                                        routerLinkActive="active"
                                                        (click)="employeeCareerRequestsNavigate('myrequests')">My
                                                        Requests</a>
                                                </li>
                                                <li *ngIf="isEmpCareerManager" class="submenu-item">
                                                    <a [routerLink]="['/Home/employee-career/employee-Career-request/team-requests']"
                                                        routerLinkActive="active"
                                                        (click)="employeeCareerRequestsNavigate('teamrequests')">Team
                                                        Requests</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <!-- <div class="image-box-two"><span class="material-symbols-outlined icon-box">group </span></div> -->
                            <a routerLinkActive="active" [routerLink]="['/Home/Skill Repository']"
                                (click)="dismissSidebar()">
                                Employee Skill Repository
                            </a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.employeeWithoutCompetency">
                            <a
                                routerLinkActive="active"
                                [routerLink]="['/Home/Missing-mandatory-fields']"
                                (click)="dismissSidebar()"
                            >
                                Employee Competency Assignment
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="Subpart_body executive_body" *ngIf="hideMenu.executive">
                <div class="subpart_header">
                    <div class=""><span class="material-symbols-outlined icon-box">rule_settings </span></div>
                    <div class="">Executive</div>
                </div>
                <div class="subpart_container">
                    <ul class="menu">
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <a routerLinkActive="active"
                                onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=76e04c44-98ba-4282-a009-a71b65409b8b&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')">
                                Executive Dashboard - 2023
                            </a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <a routerLinkActive="active"
                                onclick="window.open('https://app.powerbi.com/groups/me/reports/aecdd6f6-f055-4ef1-8f93-d251ffba5d87/ReportSectionb4855d102fdd1dfea32e?experience=power-bi')">
                                Executive Dashboard - 2024
                            </a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <a routerLinkActive="active"
                                onclick="window.open('https://app.powerbi.com/groups/me/reports/f48ee236-24bd-497d-ae1c-e23d5487a92f/ReportSection9dbc46faa1dc574d04e2?experience=power-bi')">
                                Executive Dashboard - 2023 & 2024
                            </a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <a routerLinkActive="active"
                                onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=b956e1bb-20f1-4f52-a459-1539674a0d68&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')">
                                RMG
                            </a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <a routerLinkActive="active"
                                onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=b8a3449f-7d47-4b60-9c64-ec0a863987c5&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')">
                                Sales
                            </a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <a routerLinkActive="active"
                                onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=98047a43-c119-4370-b99e-2400653a462e&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')">
                                Pre-sales
                            </a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <a routerLinkActive="active" [routerLink]="['/Home/Customer360']">
                                Customer 360 Portal
                            </a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <a routerLinkActive="active"
                                onclick="window.open('https://app.powerbi.com/reportEmbed?reportId=cce16eca-a81e-4a7f-9162-996823a113fc&autoAuth=true&ctid=7896c5aa-71b4-47c3-98d4-e707bdd7462f')">
                                GsdReview
                            </a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.skillRepository">
                            <a routerLinkActive="active"
                                onclick="window.open('https://app.powerbi.com/groups/me/reports/287abbd2-6124-4746-b8d6-ae99fa5bf21e/ReportSectiondb054d34dd265e40dd85?experience=power-bi')">
                                Global Demand Dashboard
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="Subpart_body" *ngIf="hideMenu.sales && accessForKMS">
                <div class="subpart_header">
                    <div class=""><span class="material-symbols-outlined icon-box">group </span></div>
                    <div class="">
                        KMS
                    </div>
                </div>
                <div class="subpart_container">
                    <ul class="menu">
                        <li class="menu-item" *ngIf="!hideMenu.salesdashboard">
                            <a routerLinkActive="active" [routerLink]="['/Home/KMSPortal']"
                                (click)="caseStudiesNavigate()">Dashboard</a>
                        </li>
                        <li class="menu-item" *ngIf="!hideMenu.projectcontent">
                            <a [routerLink]="['Home/KMSPortal/Project Content']" (click)="approvedProjectsNavigate()"
                                routerLinkActive="active">Project Content</a>
                        </li>
                        <li class="menu-item" *ngIf="!hideMenu.pendingapprovals">
                            <a [routerLink]="['Home/KMSPortal/Pending Approvals']" (click)="pendingProjectsNavigate()"
                                routerLinkActive="active">Pending Approvals</a>
                        </li>
                        <li class="menu-item" *ngIf="!hideMenu.users">
                            <a [routerLink]="['/users/userlist']" (click)="usersNavigate()"
                                routerLinkActive="active">Users</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="Subpart_body" *ngIf="hideMenu.portal">
                <div class="subpart_header">
                    <div class=""><span class="material-symbols-outlined icon-box">captive_portal </span></div>
                    <div class="">Portal</div>
                </div>
                <div class="subpart_container">
                    <ul class="menu">
                        <li class="menu-item" *ngIf="hideMenu.competency">
                            <a routerLinkActive="active" [routerLink]="['/Home/CMF Portal']"
                                (click)="competencyNavigate()">CMF Portal</a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.dmdPortal">
                            <a onclick="window.open('https://dmd.innovasolutions.com', '_blank')"
                                routerLinkActive="active">DMD Portal</a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.ppmPortal">
                            <a onclick="window.open('https://epas.innovasolutions.com/')" routerLinkActive="active">PPM
                                Portal</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="Subpart_body" *ngIf="hideMenu.compliance || hideMenu.timeSheet || timesheetview">
                <div class="subpart_header">
                    <div class=""><span class="material-symbols-outlined icon-box">captive_portal </span></div>
                    <div class="">Governance</div>
                </div>
                <div class="subpart_container">
                    <ul class="menu">
                        <li class="menu-item" *ngIf="hideMenu.compliance">
                            <a routerLinkActive="active" [routerLink]="['/Home/Compliance']"
                                (click)="complianceNavigate()">Compliance</a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.timesheet ||timesheetview">
                            <a routerLinkActive="active" [routerLink]="['/Home/Timesheet Management']"
                                (click)="dismissSidebar()">Timesheet Management</a>
                        </li>
                        <!-- <li class="menu-item" *ngIf="pstimesheetview">
                            <a routerLinkActive="active" [routerLink]="['/Home/People Strong Timesheet Data']"
                                (click)="dismissSidebar()">People Strong Timesheet Data</a>
                        </li>   -->
                    </ul>
                </div>
            </div>
            <div class="Subpart_body"
                *ngIf="hideMenu.proposals || hideMenu.templates || hideMenu.salaryRangeCalcualtor || hideMenu.techstack || hideMenu.poc">
                <div class="subpart_header">
                    <div class=""><span class="material-symbols-outlined icon-box">database </span></div>
                    <div class="">Others</div>
                </div>
                <div class="subpart_container">
                    <ul class="menu">
                        <li class="menu-item" *ngIf="hideMenu.proposals">
                            <a [routerLink]="['/Home/Proposal Repository']" (click)="proposalNavigate()"
                                routerLinkActive="active">Proposal Repository</a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.templates">
                            <a [routerLink]="['/Home/Home/Artifactory Repository']" (click)="templatesNavigate()"
                                routerLinkActive="active">Artifactory Repository</a>
                        </li>
                        <li class="menu-item" *ngIf="hideMenu.salaryRangeCalcualtor">
                            <a routerLinkActive="active" (click)="salaryRangeNavigate()">Salary Range Calculator</a>

                        </li>
                        <li class="menu-item" *ngIf="hideMenu.techstack">
                            <a routerLinkActive="active" [routerLink]="['/Home/ProjectTechStack']"
                                (click)="dismissSidebar()">Project Tech Stack</a>

                        </li>
                        <!-- <li class="menu-item" *ngIf="hideMenu.techstack">
                            <a routerLinkActive="active" [routerLink]="['/Home/projectdata']"
                                (click)="dismissSidebar()">Project
                                Tech Stack Data</a>

                        </li> -->

                        <!-- <li class="menu-item" *ngIf="hideMenu.techstack">
                            <a routerLinkActive="active" [routerLink]="['/Home/proposalaccelerators']"
                                (click)="dismissSidebar()">Proposal accelerators</a>

                        </li> -->
                        <li class="menu-item" *ngIf="hideMenu.poc">
                            <a routerLinkActive="active" [routerLink]="['/Home/Proof Of Concepts']"
                                (click)="dismissSidebar()">Proof of Concepts</a>
                        </li> 
                        <li class="" *ngIf="hideMenu.dashboard">
                            <div class="emp_career_item fw-600 employee_carrer">
                                Audits
                            </div>
                            <div class="Audits_body">
                                <ul class="submenu">
                                    <li class="submenu-item">
                                        
                                        <a [routerLink]="['/Home/Audit']" routerLinkActive="active"
                                            (click)="dismissSidebar()">Audits </a>
                                    </li>
                                    <li class="submenu-item">
                                        
                                        <a [routerLink]="['Home/MasterQuestion']" routerLinkActive="active"
                                            (click)="dismissSidebar()">Master Questions</a>
                                    </li>
                                    <!-- <li class="submenu-item">
                                        
                                        <a [routerLink]="['Home/TechnologyQuestions']" routerLinkActive="active"
                                            (click)="dismissSidebar()">Technology Question Mapping</a>
                                    </li> -->
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            
        </div>
    </div>
</div>